/**
 * @generated SignedSource<<48506525172c85f35d345def1aa926f8>>
 * @relayHash 532c8af1c4279d2bb763dd85b05466d5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 532c8af1c4279d2bb763dd85b05466d5

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteSickLeaveInput = {
  id: string;
};
export type useChDeleteSickLeaveMutation$variables = {
  input: Ch_deleteSickLeaveInput;
};
export type useChDeleteSickLeaveMutation$data = {
  readonly ch_deleteSickLeave: {
    readonly ch_SickLeave: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteSickLeaveMutation = {
  response: useChDeleteSickLeaveMutation$data;
  variables: useChDeleteSickLeaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteSickLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteSickLeavePayload",
        "kind": "LinkedField",
        "name": "ch_deleteSickLeave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_SickLeave",
            "kind": "LinkedField",
            "name": "ch_SickLeave",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteSickLeaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteSickLeavePayload",
        "kind": "LinkedField",
        "name": "ch_deleteSickLeave",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_SickLeave",
            "kind": "LinkedField",
            "name": "ch_SickLeave",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "532c8af1c4279d2bb763dd85b05466d5",
    "metadata": {},
    "name": "useChDeleteSickLeaveMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "220f8199008521738fa0279464b8e5bb";

export default node;
